import styles from "./PlaceholderBundle.module.css";
import {
    PlaceholderConfigInterface,
    PlaceholderStepsType,
    ProductObj,
    StepConditionType,
    StepsType,
    VariantsObj,
} from "../../Types";
import { TStoreContext } from "../../../../context/types";
import { createContext, Dispatch, SetStateAction, useContext, useEffect, useMemo, useRef, useState } from "react";
import {
    DISCOUNT_TYPES,
    DiscountTypes,
    fetchCollectionProducts,
    filterInStockProducts,
    getDiscountValueWithSignString,
    getFinalPrice,
    getPriceLabel,
    updateBundleConfigWithRealTimeProducts,
    updateBundleStats,
} from "../../constants";
import useIsMobile from "../../../../hooks/useIsMobile";
import config from "../../../../config";
import Spinner from "../../../../components/Icons/Spinner";
import {
    getCurrentPageSelectCount,
    getValidErrorMsg,
    applyConditionsBB,
    getUpdatedVariants,
    getGapForSize,
    getPlaceholderCardWidth,
    renderErrorsOnButton,
    checkForStepConditions,
    getCurrentPageSelectTotal,
    showPlaceholderItem,
    flatProductAsVariants,
    convertValueToLocal,
} from "./PlaceholderConstants";
import { RenderSubStepBadges, StepsHeaderTabs } from "./StepsHeader";
import PlaceholderStepsModal from "./PlaceholderStepsModal";
import PlusIcon from "../../../Cart/CartIcons/PlusIcon";
import ProductCard from "./PlaceholderProductCard";
import BundlePreviewWrapper from "../../BundlePreviewWrapper/BundlePreviewWrapper";
import Tooltip from "../../../../components/Tooltip/Tooltip";
import SearchIcon from "../../BundleBuilder/BundleBuilderBundle/SearchIcon";
import AngleLeftIcon from "../../../../components/Icons/AngleLeftIcon";
import { currencyToSymbols } from "../../../utilities";
import { InspectorEditableBlock } from "../../CommonFields/InspectorEditableBlock";
import { ADD_TO_CART_CLICKED, MAYUR_TEST_STORE, NAGAIA, getProductId } from "../../../constants";
import CustomScrollbar from "../../BundlesComponents/CustomScrollbar/CustomScrollbar";
import useDebounce from "../../../../hooks/useDebounce";
import { PlaceholderAccordionTemplate } from "./PlaceholderAccordianTemplate";
import BundleProgressBar from "../../BundleBuilder/BundleBuilderBundle/BundleProgressBar";

const CartIcon = ({ size = 12, color = "black" }: { size?: number; color?: string }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M3.23438 3.14063L2.31248 1.29688H0.46875M3.23438 3.14063H11.5312V5.52441C11.5312 6.35916 11.1996 7.15974 10.6094 7.75002C10.0191 8.34029 9.21853 8.67188 8.38376 8.67188H4.80811C4.39071 8.67188 3.99042 8.50609 3.6953 8.21094C3.40017 7.91581 3.23438 7.51552 3.23438 7.09815V3.14063ZM8.99609 10.0547C8.35966 10.0547 7.84373 10.5706 7.84373 11.207C7.84373 11.8435 8.35966 12.3594 8.99609 12.3594C9.63251 12.3594 10.1484 11.8435 10.1484 11.207C10.1484 10.5706 9.63251 10.0547 8.99609 10.0547ZM4.84141 10.0547C4.20499 10.0547 3.68906 10.5706 3.68906 11.207C3.68906 11.8435 4.20499 12.3594 4.84141 12.3594C5.47784 12.3594 5.99374 11.8435 5.99374 11.207C5.99374 10.5706 5.47784 10.0547 4.84141 10.0547Z"
                stroke={color}
                strokeWidth="0.9375"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

const NagaiaEmptyPlaceholderItemSVG = () => {
    return (
        <svg width="95" height="95" viewBox="0 0 95 95" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.5" width="94" height="94" rx="47" fill="#F5F6F8" stroke="#FF3F9E" strokeWidth="1" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M47.508 74.435C57.3998 74.435 61.7588 66.5068 61.7588 60.4784C61.7588 54.45 61.7588 54.6684 61.7588 44.3714C61.7588 34.0744 56.151 21.5621 55.9357 21.1328C55.7204 20.7035 55.4447 20.5808 54.9978 20.5808C54.5508 20.5808 46.9248 20.5808 47.5081 20.5808C48.0914 20.5808 40.4652 20.5808 40.0184 20.5808C39.5715 20.5808 39.2957 20.7035 39.0805 21.1328C38.8652 21.5622 33.2574 35.0374 33.2574 45.3345C33.2574 55.6315 33.2574 54.45 33.2574 60.4785C33.2574 66.5069 37.6164 74.435 47.508 74.435Z"
                stroke="#808080"
                strokeMiterlimit="10"
                fill="none"
            />
            <path
                d="M41 48C41 48.1326 41.0527 48.2598 41.1464 48.3536C41.2402 48.4473 41.3674 48.5 41.5 48.5H46.5V53.5C46.5 53.6326 46.5527 53.7598 46.6464 53.8536C46.7402 53.9473 46.8674 54 47 54C47.1326 54 47.2598 53.9473 47.3536 53.8536C47.4473 53.7598 47.5 53.6326 47.5 53.5V48.5H52.5C52.6326 48.5 52.7598 48.4473 52.8536 48.3536C52.9473 48.2598 53 48.1326 53 48C53 47.8674 52.9473 47.7402 52.8536 47.6464C52.7598 47.5527 52.6326 47.5 52.5 47.5H47.5V42.5C47.5 42.3674 47.4473 42.2402 47.3536 42.1464C47.2598 42.0527 47.1326 42 47 42C46.8674 42 46.7402 42.0527 46.6464 42.1464C46.5527 42.2402 46.5 42.3674 46.5 42.5V47.5H41.5C41.3674 47.5 41.2402 47.5527 41.1464 47.6464C41.0527 47.7402 41 47.8674 41 48Z"
                fill="#808080"
            />
        </svg>
    );
};

export interface ExtendedPlaceholderStepsType extends PlaceholderStepsType {
    gift_step?: boolean;
    is_enabled: boolean;
}

export interface PlaceholderMap {
    id: string;
    shells: any[];
    max: null | number;
    min: null | number;
    type: "step" | "free";
    conditionType: string | null;
}

type PlaceholderBundleContextType = {
    steps: ExtendedPlaceholderStepsType[] | [];
    activeStep: number;
    setActiveStep: Dispatch<SetStateAction<number>>;
    activeSubStep: number;
    setActiveSubStep: Dispatch<SetStateAction<number>>;
    selectedProducts: ProductObj[] | [];
    selectedVariants: any[];
    setSelectedProducts: Dispatch<SetStateAction<ProductObj[] | []>>;
    expandProductList: boolean;
    isMobile: boolean;
    bundleConfig: PlaceholderConfigInterface;
    totalPrice: number;
    money_format: string;
    currency: string;
    standAlone: boolean;
    productListRef: React.RefObject<HTMLDivElement>;
    isNextAllowed: any;
    nextErrorMsg: string;
    setPlaceholderStepsModal: Dispatch<SetStateAction<boolean>>;
    allStepErrors: any[];
    hasClickedAddToCartButton: boolean;
    userShopname: string;
    setSearchQuery: Dispatch<SetStateAction<string>>;
    disableCtas: (step: ExtendedPlaceholderStepsType) => boolean;
    actualConfigDiscountType: string;
    normalTotalQuantity: number;
    setNormalTotalQuantity: Dispatch<SetStateAction<number>>;
    freeGiftTotalQuantity: number;
    setFreeGiftTotalQuantity: Dispatch<SetStateAction<number>>;
};

const fetchCount = 50;

export const CheckIcon = () => {
    return (
        <svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M2.12841 10.2312L5.60299 13.7058C6.0722 14.1748 6.70851 14.4383 7.37197 14.4383C8.03544 14.4383 8.67174 14.1748 9.14095 13.7058L19.8716 2.97509C20.0235 2.81779 20.1076 2.60711 20.1057 2.38843C20.1038 2.16975 20.0161 1.96056 19.8615 1.80593C19.7068 1.65129 19.4976 1.56358 19.279 1.56168C19.0603 1.55978 18.8496 1.64384 18.6923 1.79577L7.96163 12.5264C7.80523 12.6828 7.59313 12.7706 7.37197 12.7706C7.15082 12.7706 6.93871 12.6828 6.78231 12.5264L3.30773 9.05185C3.15043 8.89992 2.93975 8.81586 2.72107 8.81776C2.50239 8.81966 2.29321 8.90737 2.13857 9.06201C1.98393 9.21665 1.89622 9.42583 1.89432 9.64451C1.89242 9.86319 1.97648 10.0739 2.12841 10.2312Z"
                fill="#FFFFDF"
                stroke="#FFFFDF"
                strokeWidth={2}
            />
        </svg>
    );
};

export const CloseIcon = ({ size = 15, color = "currentColor" }: { size?: number; color?: string }) => {
    return (
        <svg
            style={{
                minHeight: size,
                minWidth: size,
            }}
            stroke={color}
            fill={color}
            strokeWidth="10"
            viewBox="0 0 512 512"
            height={size}
            width={size}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M405 136.798L375.202 107 256 226.202 136.798 107 107 136.798 226.202 256 107 375.202 136.798 405 256 285.798 375.202 405 405 375.202 285.798 256z"></path>
        </svg>
    );
};

export const LeftArrow = ({ color = "#5E5E5E", size = 14 }: { color?: string; size?: number }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M5.46938 0.969372L0.969376 5.46937C0.899455 5.53905 0.843979 5.62184 0.806125 5.71301C0.76827 5.80417 0.748784 5.90191 0.748784 6.00062C0.748784 6.09933 0.76827 6.19707 0.806125 6.28824C0.843979 6.3794 0.899455 6.46219 0.969376 6.53187L5.46938 11.0319C5.61027 11.1728 5.80137 11.2519 6.00063 11.2519C6.19988 11.2519 6.39098 11.1728 6.53188 11.0319C6.67277 10.891 6.75193 10.6999 6.75193 10.5006C6.75193 10.3014 6.67277 10.1103 6.53188 9.96937L3.3125 6.75L12.5 6.75C12.6989 6.75 12.8897 6.67098 13.0303 6.53033C13.171 6.38967 13.25 6.19891 13.25 6C13.25 5.80108 13.171 5.61032 13.0303 5.46967C12.8897 5.32901 12.6989 5.25 12.5 5.25L3.3125 5.25L6.5325 2.03062C6.6734 1.88973 6.75255 1.69863 6.75255 1.49937C6.75255 1.30011 6.6734 1.10902 6.5325 0.968123C6.3916 0.827227 6.20051 0.74807 6.00125 0.74807C5.80199 0.74807 5.6109 0.827227 5.47 0.968123L5.46938 0.969372Z"
                fill={color}
            />
        </svg>
    );
};

const PlaceholderBundle = ({
    bundleConfig,
    targetForm,
}: {
    bundleConfig: PlaceholderConfigInterface;
    targetForm: any;
}) => {
    return (
        !!bundleConfig && (
            <PlaceholderPreview
                bundleConfig={bundleConfig}
                standAlone={true}
                appConfigContext={
                    {
                        currency: window.kefi_bundles.localization.currency,
                        money_format: window.kefi_bundles.money_format,
                        sft: window.kefi_bundles.sft,
                    } as TStoreContext
                }
                previewType={null}
                targetForm={targetForm}
            />
        )
    );
};

type Props_PlaceholderPreview = {
    bundleConfig: PlaceholderConfigInterface;
    standAlone?: boolean;
    appConfigContext: TStoreContext;
    previewType: number | null; // 1 -> mobile, 2 -> desktop, null-> storefront view
    targetForm: any;
    inspectorMode?: boolean;
    placement?: "bundle" | "swatches";
};

const PlaceholderBottomSection = () => {
    const {
        steps,
        setActiveStep,
        activeStep,
        totalPrice,
        isMobile,
        bundleConfig,
        money_format,
        currency,
        standAlone,
        isNextAllowed,
        nextErrorMsg,
        totalQuantity,
        normalTotalQuantity,
        tierSuccessMessage,
        setPlaceholderStepsModal,
        userShopname,
        actualConfigDiscountType,
    } = useContext(PlaceholderBundleContext);

    const targetShops = ["dev-store-0124.myshopify.com", MAYUR_TEST_STORE, NAGAIA];
    const minusValue = targetShops.includes(userShopname as string) ? 2 : 1; // we don't want to show the last step next btn for targetshops, directly show done btn

    return (
        <InspectorEditableBlock bundleType={bundleConfig?.bundle_type} settingKey="bottomBar">
            <div
                className={styles.placeholderBottomSectionWrapper}
                style={{
                    background: bundleConfig?.bundles_design?.total_footer_background_color,
                    borderRadius: bundleConfig?.bundles_design?.border_radius,
                    minWidth: isMobile ? "80vw" : 250,
                    boxShadow: "0px 3px 5px -1px #000000",
                    bottom: "16px",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        position: "absolute",
                        top: 0,
                        padding: "6px 14px",
                        gap: 10,
                        background: "#FFFFFF",
                        border: `1px solid ${bundleConfig?.bundles_design?.modal_footer_bg}`,
                        borderRadius: 60,
                        zIndex: 10,
                        transform: "translate(0, -50%)",
                    }}
                >
                    {!(
                        bundleConfig?.hide_prices_product_card && bundleConfig?.discount_type == DISCOUNT_TYPES.FIXED
                    ) && (
                        <div className={styles.priceWrapper}>
                            {(() => {
                                const finalCalculatedPrice = Math.max(
                                    0,
                                    getFinalPrice(
                                        bundleConfig?.discount_type,
                                        bundleConfig?.discount_value || 0,
                                        totalPrice,
                                    ),
                                );
                                return (
                                    <>
                                        {+bundleConfig?.discount_value > 0 &&
                                            totalPrice != null &&
                                            bundleConfig?.discount_type !== DISCOUNT_TYPES?.NONE &&
                                            totalPrice > finalCalculatedPrice && (
                                                <InspectorEditableBlock
                                                    bundleType={bundleConfig?.bundle_type}
                                                    settingKey="footerCompareAtPrice"
                                                >
                                                    <span
                                                        className={styles.strikeOffPrice}
                                                        style={{
                                                            fontSize: bundleConfig?.bundles_design.product_price_size,
                                                            color: bundleConfig?.bundles_design.product_price_color,
                                                            fontWeight:
                                                                bundleConfig?.bundles_design?.product_price_style?.split(
                                                                    " ",
                                                                )[0],
                                                            fontStyle:
                                                                bundleConfig?.bundles_design?.product_price_style?.split(
                                                                    " ",
                                                                )[1],
                                                            whiteSpace: "nowrap",
                                                        }}
                                                    >
                                                        {getPriceLabel(
                                                            totalPrice as unknown as string,
                                                            money_format,
                                                            currency,
                                                        )}
                                                    </span>
                                                </InspectorEditableBlock>
                                            )}
                                        <InspectorEditableBlock
                                            bundleType={bundleConfig?.bundle_type}
                                            settingKey="footerTotalPrice"
                                        >
                                            <span
                                                className={styles.finalPrice}
                                                style={{
                                                    color: bundleConfig?.bundles_design?.total_footer_price_text_color,
                                                    fontSize:
                                                        bundleConfig?.bundles_design?.total_footer_price_text_size,
                                                    fontWeight:
                                                        bundleConfig?.bundles_design?.total_footer_price_text_style?.split(
                                                            " ",
                                                        )[0],
                                                    fontStyle:
                                                        bundleConfig?.bundles_design?.total_footer_price_text_style?.split(
                                                            " ",
                                                        )[1],
                                                    whiteSpace: "nowrap",
                                                }}
                                            >
                                                {getPriceLabel(finalCalculatedPrice, money_format, currency)}
                                            </span>
                                        </InspectorEditableBlock>
                                    </>
                                );
                            })()}
                        </div>
                    )}
                    <span
                        style={{
                            display: "flex",
                            height: bundleConfig?.bundles_design?.total_footer_price_text_size + 10 + "px",
                            width: 1,
                            opacity: 0.5,
                            background: bundleConfig?.bundles_design?.modal_footer_bg,
                        }}
                    ></span>
                    <InspectorEditableBlock bundleType={bundleConfig?.bundle_type} settingKey="footerTotalQuantity">
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: 4,
                                color: bundleConfig?.bundles_design?.total_footer_price_text_color,
                                fontSize: bundleConfig?.bundles_design?.total_footer_price_text_size,
                                fontWeight: bundleConfig?.bundles_design?.total_footer_price_text_style?.split(" ")[0],
                                fontStyle: bundleConfig?.bundles_design?.total_footer_price_text_style?.split(" ")[1],
                            }}
                        >
                            {totalQuantity}
                            <span
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <CartIcon size={bundleConfig?.bundles_design?.total_footer_price_text_size || 14} />
                            </span>
                        </div>
                    </InspectorEditableBlock>
                </div>

                <span className={styles.bottomSectionWrapper}>
                    <div
                        className={styles.bottomRightSection}
                        style={{
                            width: standAlone && isMobile && activeStep > 0 ? "80vw" : "",
                        }}
                    >
                        <div className={styles.totalWrapper}></div>

                        <div style={{ minWidth: "270px" }}>
                            <BundleProgressBar
                                bundleConfig={bundleConfig}
                                totalPrice={totalPrice}
                                totalQuantity={normalTotalQuantity}
                                currency={currency}
                                money_format={money_format}
                                tierSuccessMessage={tierSuccessMessage}
                                actualConfigDiscountType={actualConfigDiscountType}
                                messagePlacement="bottom"
                            />
                        </div>

                        {!!steps?.length && (
                            <div className={styles.bottomCtasRow}>
                                {activeStep > 0 && (
                                    <Tooltip text={""} tooltipWrapperStyle={{ width: "100%" }}>
                                        <InspectorEditableBlock
                                            bundleType={bundleConfig?.bundle_type}
                                            settingKey="previousCta"
                                        >
                                            <button
                                                onClick={() => {
                                                    sessionStorage.setItem("goToStep", "prev");
                                                    setActiveStep((ps: PlaceholderBundleContextType["activeStep"]) =>
                                                        ps == 0 ? ps : ps - 1,
                                                    );
                                                }}
                                                className={`${styles.bottomCta} ${styles.tertiary}  ${styles.previous} `}
                                                disabled={activeStep == 0}
                                                style={{
                                                    background: bundleConfig?.bundles_design?.tertiary_cta_bg_color,
                                                    color: bundleConfig?.bundles_design?.tertiary_cta_text_color,
                                                    border: `1px solid ${bundleConfig?.bundles_design?.tertiary_cta_bg_color}`,
                                                }}
                                            >
                                                {bundleConfig?.previous_cta_text}
                                            </button>
                                        </InspectorEditableBlock>
                                    </Tooltip>
                                )}
                                <Tooltip
                                    text={
                                        renderErrorsOnButton(nextErrorMsg, true).map((line: string, idx: number) => (
                                            <div key={idx}>{line}</div>
                                        )) as string
                                    }
                                    position={"top"}
                                    tooltipWrapperStyle={{ width: "100%" }}
                                >
                                    <InspectorEditableBlock bundleType={bundleConfig?.bundle_type} settingKey="nextCta">
                                        <button
                                            style={{
                                                background: bundleConfig?.bundles_design?.secondary_cta_bg_color,
                                                color: bundleConfig?.bundles_design?.secondary_cta_text_color,
                                                border: `1px solid ${bundleConfig?.bundles_design?.secondary_cta_bg_color}`,
                                            }}
                                            onClick={() => {
                                                if (isNextAllowed(steps[activeStep])) {
                                                    sessionStorage.setItem("goToStep", "next");
                                                    if (activeStep >= steps?.length - minusValue) {
                                                        setPlaceholderStepsModal(false);
                                                    } else {
                                                        setActiveStep(
                                                            (ps: PlaceholderBundleContextType["activeStep"]) =>
                                                                ps == steps?.length - 1 ? ps : ps + 1,
                                                        );
                                                    }
                                                }
                                            }}
                                            disabled={!isNextAllowed(steps[activeStep])}
                                            className={`${styles.bottomCta} ${styles.secondary} ${styles.next} `}
                                        >
                                            {activeStep >= steps?.length - minusValue
                                                ? bundleConfig?.done_cta_text
                                                : bundleConfig?.next_cta_text}
                                        </button>
                                    </InspectorEditableBlock>
                                </Tooltip>
                            </div>
                        )}
                    </div>
                </span>
            </div>
        </InspectorEditableBlock>
    );
};

const PlaceholderProduct = ({
    product,
    parentIdx,
    handleRemoveProduct,
}: {
    product: ProductObj;
    parentIdx: number;
    handleRemoveProduct: (idx: any, productId: string, variantId: string, subStepIdx?: number) => void;
    freeGift: boolean;
}) => {
    const { bundleConfig, setActiveStep, setPlaceholderStepsModal } = useContext(PlaceholderBundleContext);
    const addedQuantity = Number((product as any)?.qty) || product?.selectedVariants?.length || 1;

    const [img, setImg] = useState({ altText: "", originalSrc: "" });
    useEffect(() => {
        getVariantImage(product.selectedVariants);
    }, [product.selectedVariants]);

    const getVariantImage = (sv: any) => {
        if (sv.length >= 1) {
            setImg(sv[0]?.image?.originalSrc ? sv[0]?.image : product?.images?.[0]);
        } else {
            setImg(product?.images?.[0]);
        }
    };

    const disableQuantitySelectorForPreselectedProducts = () => {
        if (!bundleConfig?.make_pre_selected_compulsory) {
            return false;
        }

        const preSelected = bundleConfig?.pre_selected_products;
        const isCurProductInPreSelected = preSelected.find((p: any) => p.id === product?.parentProduct);
        if (isCurProductInPreSelected) {
            return true;
        }

        return false;
    };

    return (
        <InspectorEditableBlock bundleType={bundleConfig?.bundle_type} settingKey="productCard">
            <div
                className={styles.selectedProduct}
                style={{
                    border: `${bundleConfig?.bundles_design?.border_width}px solid ${bundleConfig?.bundles_design?.product_border_color}`,
                    borderRadius: bundleConfig?.bundles_design?.border_radius,
                    backgroundColor: bundleConfig?.bundles_design.product_background_color,
                }}
                onClick={() => {
                    setActiveStep(parentIdx);
                    setPlaceholderStepsModal(true);
                }}
            >
                {!disableQuantitySelectorForPreselectedProducts() && (
                    <span
                        className={`${styles.removeSpProduct} 
                `}
                        onClick={(e) => {
                            e?.preventDefault();
                            e?.stopPropagation();
                            console._log(product);
                            handleRemoveProduct(
                                parentIdx,
                                product?.parentProduct || "",
                                product?.selectedVariants?.[0]?.id || "",
                                product?.subStepIdx,
                            );
                        }}
                    >
                        <CloseIcon size={14} color="#303030" />
                    </span>
                )}

                <div
                    style={{
                        overflow: "hidden",
                        width: "100%",
                        height: "100%",
                        borderRadius:
                            bundleConfig?.bundles_design?.border_radius - bundleConfig?.bundles_design?.border_width,
                    }}
                >
                    <img
                        src={img?.originalSrc}
                        alt={img?.altText}
                        style={{
                            objectFit: "cover",
                            minWidth: "100%",
                            minHeight: "100%",
                            maxWidth: "100%",
                            maxHeight: "100%",
                        }}
                    />
                </div>
                {addedQuantity > 0 && (
                    <InspectorEditableBlock bundleType={bundleConfig?.bundle_type} settingKey="addedQuantity">
                        <span
                            className={styles.selectedProductQtyCount}
                            style={{
                                minWidth: bundleConfig?.bundles_design?.added_quantity_text_size + 4,
                                minHeight: bundleConfig?.bundles_design?.added_quantity_text_size + 4,
                                background: bundleConfig?.bundles_design?.added_quantity_bg_color,
                                color: bundleConfig?.bundles_design?.added_quantity_text_color || "#ffffff",
                                fontSize: bundleConfig?.bundles_design?.added_quantity_text_size,
                                fontWeight:
                                    bundleConfig?.bundles_design?.added_quantity_text_style?.split(" ")[0] || 550,
                                fontStyle:
                                    bundleConfig?.bundles_design?.added_quantity_text_style?.split(" ")[1] || "normal",
                            }}
                        >
                            {addedQuantity}
                        </span>
                    </InspectorEditableBlock>
                )}
            </div>
        </InspectorEditableBlock>
    );
};

const EmptyPlaceholderItem = ({
    handler,
    placeholderItem,
    products,
    text = "Add Product",
    minHeight,
}: {
    handler: () => void;
    placeholderItem: PlaceholderMap;
    products: any;
    span: number;
    text?: string;
    minHeight: any;
}) => {
    const { bundleConfig } = useContext(PlaceholderBundleContext);
    const [show, setShow] = useState(false);
    useEffect(() => {
        if (placeholderItem) {
            const maxRule = placeholderItem?.max || null;
            const minRule = placeholderItem?.min || null;
            const totalProducts = products?.length;
            if (maxRule != null && minRule != null && totalProducts >= maxRule && totalProducts >= minRule) {
                setShow(false);
            } else if (maxRule != null && totalProducts >= maxRule) {
                setShow(false);
            } else {
                setShow(true);
            }
        } else {
            setShow(true);
        }
    }, [placeholderItem?.max, placeholderItem?.min, products]);

    return show ? (
        <InspectorEditableBlock bundleType={bundleConfig?.bundle_type} settingKey="placeholderItemWrapper">
            <div
                onClick={handler}
                className={`${styles.placeholderItemWrapper} `}
                style={{
                    width: "100%",
                    minHeight: minHeight,
                    borderColor: bundleConfig?.bundles_design?.dotted_border_color,
                    backgroundColor: bundleConfig?.bundles_design?.step_container_bg,
                }}
            >
                <span className={styles.piwIcon}>
                    <PlusIcon size={20} color={bundleConfig?.bundles_design?.dotted_border_color} />
                </span>
                <span
                    className={styles.piwText}
                    style={{
                        color: bundleConfig?.bundles_design?.dotted_border_color,
                    }}
                >
                    {text}
                </span>
            </div>
        </InspectorEditableBlock>
    ) : (
        <></>
    );
};

type NagaiaEmptyPlaceholderItemProps = {
    index: number;
    setActiveStep: (index: number) => void;
    setPlaceholderStepsModal: (val: boolean) => void;
    placeholderItem: PlaceholderMap;
    _products: any;
};

const NagaiaEmptyPlaceholderItem = ({
    index,
    setActiveStep,
    setPlaceholderStepsModal,
    placeholderItem,
    _products,
}: NagaiaEmptyPlaceholderItemProps) => {
    const getNumberOfSVGs = () => {
        if (
            placeholderItem.max !== null &&
            placeholderItem.min !== null &&
            placeholderItem.max === placeholderItem.min
        ) {
            // exact_products
            return placeholderItem.max;
        } else if (placeholderItem.max !== null) {
            // max_products
            return placeholderItem.max;
        } else if (placeholderItem.min !== null) {
            // min_products
            return placeholderItem.min;
        }
        return 5; // default
    };

    const totalQty = getCurrentPageSelectCount(_products, index);
    const numRequired = getNumberOfSVGs();
    const numEmpty = Math.max(0, numRequired - totalQty);

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
                width: "100%",
                maxWidth: "100%",
            }}
        >
            <div
                style={{
                    display: "flex",
                    gap: "10px",
                    paddingTop: "10px",
                }}
            >
                {Array.from({ length: numEmpty }).map((_, idx) => {
                    return (
                        <div
                            key={`svg-${index}-${idx}`}
                            onClick={() => {
                                setActiveStep(index);
                                setPlaceholderStepsModal(true);
                            }}
                            style={{
                                cursor: "pointer",
                            }}
                        >
                            <NagaiaEmptyPlaceholderItemSVG />
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

const PlaceholderSection = ({
    placeholderItem,
    setPlaceholderStepsModal,
    index,
}: {
    placeholderItem: PlaceholderMap;
    setPlaceholderStepsModal: Dispatch<SetStateAction<boolean>>;
    index: number;
}) => {
    const {
        bundleConfig,
        setPlaceholderMap,
        placeholderMap,
        selectedVariants,
        setActiveStep,
        isMobile,
        allStepErrors,
        hasClickedAddToCartButton,
        steps,
        userShopname,
    } = useContext(PlaceholderBundleContext);

    const needCollapse = placeholderMap?.length > 1;

    const [expanded, setExpanded] = useState(index > 2 ? false : true);

    const handleRemoveProduct = (shellId: number, productId: string, variantId: string, subStepIdx?: number) => {
        setPlaceholderMap((ps: PlaceholderMap[]) => {
            const temp = [...ps];
            const currentShell = temp[shellId];

            if (!currentShell || !Array.isArray(currentShell.shells)) {
                return ps;
            }

            const updatedShells = currentShell.shells
                .map((shell) => {
                    if (shell.id === productId && (subStepIdx !== undefined ? shell.subStepIdx === subStepIdx : true)) {
                        const updatedVariants = shell.selectedVariants?.filter(
                            (variant: any) => variant.id !== variantId,
                        );

                        if (!updatedVariants || updatedVariants.length === 0) {
                            return null;
                        }

                        return {
                            ...shell,
                            selectedVariants: updatedVariants,
                        };
                    }

                    return shell;
                })
                .filter(Boolean); // remove nulls (products with no variants left)

            temp[shellId] = {
                ...currentShell,
                shells: updatedShells,
            };

            return temp;
        });
    };

    const _products = selectedVariants?.filter((product: any) => product?.page == index);
    const columns = isMobile ? 3 : 4;
    const productCount = _products.length;

    const currPageItemCount = getCurrentPageSelectCount(_products, index);
    const currPageTotalValue = getCurrentPageSelectTotal(_products, index);

    const showEmptyPlaceholderItem = showPlaceholderItem(
        steps?.[index]?.step_conditions,
        currPageItemCount,
        currPageTotalValue,
    );

    useEffect(() => {
        if (!needCollapse) return;
        if (bundleConfig?.no_close_accordian_after_completion) {
            setExpanded(true);
            return;
        }
        setExpanded(index > 2 ? false : showEmptyPlaceholderItem ? true : false);
    }, [currPageItemCount, currPageTotalValue, bundleConfig?.no_close_accordian_after_completion]);

    let span = isMobile ? 3 : 4; // default full-width (when 0 or full row)
    if (productCount > 0) {
        span = columns - (productCount % columns);
    }

    const isExactProducts =
        steps[index]?.show_step_conditions &&
        placeholderItem.max !== null &&
        placeholderItem.min !== null &&
        placeholderItem.max > 1 &&
        placeholderItem.min > 1 &&
        placeholderItem.max === placeholderItem.min &&
        placeholderItem.conditionType === "items_count";
    const numEmpty = isExactProducts
        ? Math.max(0, (placeholderItem.max || 0) - currPageItemCount)
        : showEmptyPlaceholderItem
          ? 1
          : 0;
    const placeholderSpan = isExactProducts ? 1 : span;

    const placeholderStyle = {
        gridColumn: `span ${placeholderSpan}`,
        ...(isExactProducts && { aspectRatio: "1 / 1" }),
    };

    const targetShops = ["dev-store-0124.myshopify.com", MAYUR_TEST_STORE, NAGAIA, "testbundle22.myshopify.com"];
    const getSelectedProductKey = (product: any, pIdx: number) =>
        `${index}-${product?.parentProduct || "product"}-${product?.id || "variant"}-${product?.subStepIdx ?? "na"}-${pIdx}`;

    return (
        <div className={styles.placeholderSectionWrapper}>
            <InspectorEditableBlock bundleType={bundleConfig?.bundle_type} settingKey="stepLabel">
                <div
                    style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}
                >
                    <span
                        style={{
                            textAlign: "left",
                            color: bundleConfig?.bundles_design?.step_label_color,
                            fontSize: bundleConfig?.bundles_design?.step_label_size,
                            fontWeight: bundleConfig?.bundles_design?.step_label_style?.split(" ")[0],
                            fontStyle: bundleConfig?.bundles_design?.step_label_style?.split(" ")[1],
                            lineHeight: "normal",
                        }}
                    >
                        {placeholderItem?.id?.split(":")[1]}
                    </span>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        {(steps[index]?.step_conditions?.findIndex((s: any) => s.type === "exact_products") >= 0 ||
                            (steps[index]?.gift_step && steps[index]?.step_condition_type === "exact_products")) &&
                            placeholderItem.max != null &&
                            placeholderItem.min != null &&
                            steps[index]?.show_step_conditions && (
                                <span
                                    style={{
                                        fontSize: "12px",
                                        color: currPageItemCount == placeholderItem.max ? "green" : "red",
                                        whiteSpace: "nowrap",
                                        marginLeft: 6,
                                        lineHeight: "normal",
                                    }}
                                >
                                    {placeholderItem?.conditionType == "bundle_total"
                                        ? currPageTotalValue
                                        : currPageItemCount}{" "}
                                    of {placeholderItem.max}
                                </span>
                            )}
                        {needCollapse && (
                            <span
                                onClick={(e) => {
                                    e?.stopPropagation();
                                    e.preventDefault();
                                    setExpanded((ps) => !ps);
                                }}
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    transform: expanded ? "rotate(90deg)" : "rotate(270deg)",
                                    cursor: "pointer",
                                }}
                            >
                                <AngleLeftIcon size={16} color={bundleConfig?.bundles_design?.step_label_color} />
                            </span>
                        )}
                    </div>
                </div>
            </InspectorEditableBlock>
            {expanded && (
                <>
                    {_products?.length ? (
                        <>
                            {targetShops?.includes(userShopname as string) ? (
                                <CustomScrollbar direction="horizontal">
                                    <div className={`${styles.horizontalScrollWrapper} `}>
                                        <div className={styles.horizontalRow}>
                                            {_products.map((product: any, pIdx: number) => (
                                                <div
                                                    key={getSelectedProductKey(product, pIdx)}
                                                    className={styles.productItem}
                                                    style={{ maxWidth: "98px", paddingTop: "10px", flexShrink: 0 }}
                                                >
                                                    <PlaceholderProduct
                                                        product={product}
                                                        parentIdx={index}
                                                        handleRemoveProduct={handleRemoveProduct}
                                                        freeGift={placeholderItem?.type == "free"}
                                                    />
                                                </div>
                                            ))}

                                            <div style={{ flexShrink: 0 }}>
                                                <NagaiaEmptyPlaceholderItem
                                                    index={index}
                                                    placeholderItem={placeholderItem}
                                                    setActiveStep={setActiveStep}
                                                    setPlaceholderStepsModal={setPlaceholderStepsModal}
                                                    _products={_products}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </CustomScrollbar>
                            ) : (
                                <div
                                    className={`${styles.placeholderProducts} ${isMobile && styles.placeholderProductsMobile}`}
                                >
                                    {_products?.map((product: any, pIdx: number) => {
                                        return (
                                            <PlaceholderProduct
                                                key={getSelectedProductKey(product, pIdx)}
                                                product={product}
                                                parentIdx={index}
                                                handleRemoveProduct={handleRemoveProduct}
                                                freeGift={placeholderItem?.type == "free"}
                                            />
                                        );
                                    })}
                                    {Array.from({ length: numEmpty }).map((_, idx) => (
                                        <div key={idx} style={placeholderStyle}>
                                            <EmptyPlaceholderItem
                                                handler={() => {
                                                    setActiveStep(index);
                                                    setPlaceholderStepsModal(true);
                                                }}
                                                placeholderItem={placeholderItem}
                                                products={_products}
                                                span={placeholderSpan}
                                                text={bundleConfig?.edit_cta_text}
                                                minHeight={70}
                                            />
                                        </div>
                                    ))}
                                </div>
                            )}
                        </>
                    ) : targetShops?.includes(userShopname as string) ? (
                        <CustomScrollbar direction="horizontal">
                            <div className={`${styles.horizontalScrollWrapper}`}>
                                <NagaiaEmptyPlaceholderItem
                                    index={index}
                                    placeholderItem={placeholderItem}
                                    setActiveStep={setActiveStep}
                                    setPlaceholderStepsModal={setPlaceholderStepsModal}
                                    _products={[]}
                                />
                            </div>
                        </CustomScrollbar>
                    ) : (
                        <div
                            className={`${styles.placeholderProducts} ${isMobile && styles.placeholderProductsMobile}`}
                        >
                            {Array.from({ length: numEmpty }).map((_, idx) => (
                                <div key={idx} style={placeholderStyle}>
                                    <EmptyPlaceholderItem
                                        handler={() => {
                                            setActiveStep(index);
                                            setPlaceholderStepsModal(true);
                                        }}
                                        placeholderItem={placeholderItem}
                                        products={[]}
                                        span={placeholderSpan}
                                        text={bundleConfig?.edit_cta_text}
                                        minHeight={90}
                                    />
                                </div>
                            ))}
                        </div>
                    )}
                </>
            )}
            {hasClickedAddToCartButton &&
                allStepErrors?.[index]?.errors?.map((e: string) => (
                    <p
                        style={{
                            margin: 0,
                            padding: 0,
                            lineHeight: "normal",
                            fontSize: 12,
                            color: "red",
                        }}
                    >
                        {e}
                    </p>
                ))}
        </div>
    );
};

export const PlaceholderBundleContext = createContext<PlaceholderBundleContextType | any>({});

export const PlaceholderPreview = ({
    bundleConfig,
    appConfigContext,
    standAlone = false,
    previewType = null,
    targetForm = null,
    inspectorMode = false,
    placement = "bundle",
}: Props_PlaceholderPreview) => {
    const { money_format, currency, sft } = appConfigContext;
    const { isMobile: _isMobile } = useIsMobile();
    const appName = config.appName;
    const isMobile = _isMobile;
    const [activeStep, setActiveStep] = useState(0);
    const [steps, setSteps] = useState<ExtendedPlaceholderStepsType[]>([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [searchActive, setSearchActive] = useState(false);
    const [totalPrice, setTotalPrice] = useState<number | null>(null);
    const [listProducts, setListProducts] = useState<ProductObj[]>([]);
    const [loadingMore, setLoadingMore] = useState(false);
    const [loadingProducts, setLoadingProducts] = useState(false);
    const [selectedVariants, setSelectedVariants] = useState<any[]>([]);
    const [pageInfo, setPageInfo] = useState<any>(null); // 🆕 state to store page info
    const loadMoreTriggerRef = useRef<HTMLDivElement | null>(null);
    const productListRef = useRef<HTMLDivElement>(null);
    const [boxQuantity, setBoxQuantity] = useState(1);
    const [currentPageSelectCount, setCurrentPageSelectCount] = useState(0);
    const [currentPageSelectTotal, setCurrentPageSelectTotal] = useState(0);
    const [nextErrorMsg, setNextErrorMsg] = useState<string[]>([]);
    const [totalQuantity, setTotalQuantity] = useState(0);
    const [normalTotalQuantity, setNormalTotalQuantity] = useState(0);
    const [freeGiftTotalQuantity, setFreeGiftTotalQuantity] = useState(0);
    const [discountType, setDiscountType] = useState<DiscountTypes>("none");
    const [discountValue, setDiscountValue] = useState<number | null>(0);
    const [tierSuccessMessage, setTierSuccessMessage] = useState("");
    const [placeholderMap, setPlaceholderMap] = useState<PlaceholderMap[]>([]);
    const [isAddCartDisabled, setIsAddCartDisabled] = useState(true);
    const [placeholderStepsModal, setPlaceholderStepsModal] = useState(false);
    const [hasClickedAddToCartButton, setHasClickedAddToCartButton] = useState(false);
    const [allStepErrors, setAllStepErrors] = useState<any[]>([]);
    const [hasStepErrorsLeft, setHasStepErrorsLeft] = useState<boolean>(true);
    const [activeSubStep, setActiveSubStep] = useState(0);
    const [predictiveResults, setPredictiveResults] = useState<ProductObj[]>([]);
    const [isSearching, setIsSearching] = useState(false);
    const abortControllerRef = useRef<AbortController | null>(null);
    const userShopname = standAlone ? window.kefi_bundles.shop : shopify.config.shop;
    const debouncedSearchQuery = useDebounce(searchQuery, 500);

    useEffect(() => {
        setActiveSubStep(0);
        setSearchQuery("");
    }, [activeStep]);

    useEffect(() => {
        for (let i = 0; i < steps.length; i++) {
            let stepMsg = "";
            let msg: string[] = [];
            const count = getCurrentPageSelectCount(selectedVariants, i);
            const total = getCurrentPageSelectTotal(selectedVariants, i);

            if (steps[i]?.step_conditions) {
                steps[i]?.step_conditions?.forEach((condition: StepConditionType) => {
                    stepMsg = "";
                    stepMsg = getValidErrorMsg(steps[i], condition, count, total, currency, currencyToSymbols);
                    if (stepMsg) {
                        msg.push(stepMsg);
                    }
                });
                if (!steps[i]?.show_step_conditions) {
                    msg = [];
                }
            }
            if (steps[i].gift_step) {
                stepMsg = getValidErrorMsg(
                    steps[i],
                    steps[i].step_conditions,
                    count,
                    total,
                    currency,
                    currencyToSymbols,
                );
                if (stepMsg) {
                    msg.push(stepMsg);
                }
            }

            setAllStepErrors((prevErrors) => {
                const newErrors = [...prevErrors];
                const existingStepIndex = prevErrors.findIndex((error) => error.stepIndex === i);
                if (existingStepIndex !== -1) {
                    newErrors[existingStepIndex] = { stepIndex: i, errors: msg };
                } else {
                    newErrors.push({ stepIndex: i, errors: msg });
                }

                return newErrors;
            });
        }
    }, [selectedVariants]);

    useEffect(() => {
        const errorsExist = allStepErrors.some((step) => step.errors.length > 0);
        setHasStepErrorsLeft(errorsExist);
    }, [allStepErrors]);

    useEffect(() => {
        const handleAddToCartClicked = () => {
            setHasClickedAddToCartButton(true);
        };
        document.addEventListener(ADD_TO_CART_CLICKED, handleAddToCartClicked);
        return () => {
            document.removeEventListener(ADD_TO_CART_CLICKED, handleAddToCartClicked);
        };
    }, []);

    useEffect(() => {
        if (steps?.length > 0) {
            const pm: PlaceholderMap[] = [];
            steps?.forEach((step, idx: number) => {
                const isGiftStep = step?.gift_step;
                const hasExactProductsCondition = step?.step_conditions?.find(
                    (condition) => condition.type === "exact_products",
                );
                const hasMaxProductsCondition = step?.step_conditions?.find(
                    (condition) => condition.type === "max_products",
                );
                const hasMinProductsCondition = step?.step_conditions?.find(
                    (condition) => condition.type === "min_products",
                );

                const giftStepLimitType = step?.step_condition_type;
                const giftStepLimit = step?.product_count_limit;

                // Determine min and max
                const max = isGiftStep
                    ? giftStepLimitType === "max_products" || giftStepLimitType === "exact_products"
                        ? giftStepLimit
                        : null
                    : hasExactProductsCondition
                      ? hasExactProductsCondition.limit
                      : hasMaxProductsCondition
                        ? hasMaxProductsCondition.limit
                        : null;

                const min = isGiftStep
                    ? giftStepLimitType === "min_products" || giftStepLimitType === "exact_products"
                        ? giftStepLimit
                        : null
                    : hasExactProductsCondition
                      ? hasExactProductsCondition.limit
                      : hasMinProductsCondition
                        ? hasMinProductsCondition.limit
                        : null;

                const conditionType = isGiftStep
                    ? giftStepLimitType
                    : hasExactProductsCondition
                      ? hasExactProductsCondition.basis
                      : null;

                pm.push({
                    id: `${idx}:${step?.step_label}`,
                    shells: placeholderMap?.[idx]?.shells || [],
                    max: max ?? null,
                    min: min ?? null,
                    type: isGiftStep ? "free" : "step",
                    conditionType: conditionType ?? null,
                });
            });
            setPlaceholderMap([...pm]);
        } else {
            setPlaceholderMap([]);
        }
    }, [steps]);

    const getDiscountOption = () => {
        const tiers = bundleConfig?.discount_options || [];
        const basis = bundleConfig?.tier_discount_basis;

        if (basis === "product_based") {
            let bestTier: any = null;
            let maxDiscountAmount = -1;

            const selectedProductsInBundle = placeholderMap.flatMap((pm) => pm.shells || []);

            for (const tier of tiers) {
                if (!tier.selected_products || tier.selected_products.length === 0) continue;

                const hasMatchingProduct = selectedProductsInBundle.some((bundleProd: any) =>
                    tier.selected_products?.some(
                        (tierProd: any) =>
                            getProductId(tierProd.id) === getProductId(bundleProd.id) ||
                            (tierProd.shopifyId && getProductId(tierProd.shopifyId) === getProductId(bundleProd.id)) ||
                            (bundleProd.shopifyId && getProductId(tierProd.id) === getProductId(bundleProd.shopifyId)),
                    ),
                );

                if (hasMatchingProduct) {
                    let currentAmount = 0;
                    const val = tier.discountValue || 0;
                    const currentTotalPrice = totalPrice || 0;

                    if (tier.discountType === "percentage") {
                        currentAmount = (currentTotalPrice * val) / 100;
                    } else if (tier.discountType === "flat") {
                        currentAmount = val;
                    } else if (tier.discountType === "fixed") {
                        currentAmount = Math.max(0, currentTotalPrice - val);
                    }

                    if (currentAmount > maxDiscountAmount) {
                        maxDiscountAmount = currentAmount;
                        bestTier = tier;
                    }
                }
            }
            return bestTier;
        }

        const compareWith = (basis === "bundle_total" ? totalPrice : normalTotalQuantity) || 0;
        let applicableTier = null;

        for (let i = 0; i < tiers.length; i++) {
            const current = tiers[i];
            const next = tiers[i + 1];
            const currentQ = basis == "bundle_total" ? convertValueToLocal(current.quantity) : current.quantity;
            let nextQ = 0;
            if (next) {
                nextQ = basis == "bundle_total" ? convertValueToLocal(next.quantity) : next.quantity;
            }

            if (current.addRange) {
                // qualifies if >= current.quantity but < next.quantity
                if (compareWith >= currentQ && (!next || compareWith < nextQ)) {
                    applicableTier = current;
                    break;
                }
            } else {
                // must exactly match the quantity
                if (compareWith === currentQ) {
                    applicableTier = current;
                    break;
                }
            }
        }
        return applicableTier;
    };

    const getNextTierOption = (applicableDiscount: any, compareWith: number) => {
        const basis = bundleConfig?.tier_discount_basis;
        if (basis === "product_based") {
            return null;
        }
        const validDiscountIdx = bundleConfig?.discount_options.findIndex((opt) => opt.id === applicableDiscount?.id);

        if (validDiscountIdx >= bundleConfig?.discount_options?.length - 1) {
            return { completeStatus: true } as any;
        }
        const options = bundleConfig?.discount_options || [];
        for (let i = validDiscountIdx === -1 ? 0 : validDiscountIdx + 1; i < options.length; i++) {
            const opt = options[i];
            const optQ = basis === "bundle_total" ? convertValueToLocal(opt.quantity) : opt.quantity;
            if (opt && optQ - compareWith > 0) {
                return basis === "bundle_total" ? { ...opt, quantity: optQ } : { ...opt };
            }
        }
        return null;
    };

    useEffect(() => {
        if (bundleConfig?.discount_type === "tier" && bundleConfig?.discount_options?.length > 0) {
            const basis = bundleConfig?.tier_discount_basis;
            const compareWith = basis === "bundle_total" ? totalPrice : normalTotalQuantity;

            const applicableDiscount = getDiscountOption();
            const nextTierOption = getNextTierOption(applicableDiscount, compareWith || 0);

            const isTierCompleted =
                !!nextTierOption?.completeStatus &&
                !!bundleConfig?.discount_options.find((opt) => opt.showFinalSuccessMessage)?.showFinalSuccessMessage;

            setDiscountType(applicableDiscount?.discountType || "none");
            setDiscountValue(applicableDiscount?.discountValue || 0);

            if (nextTierOption?.ShowTierSuccessMessage && nextTierOption?.TierSuccessMessage) {
                const msg = nextTierOption.TierSuccessMessage.replace(
                    "{noOfRemainingProducts}",
                    (nextTierOption.quantity - (compareWith || 0)).toString(),
                )
                    .replace(
                        "{remainingAmount}",
                        `${getPriceLabel(
                            Math.round((nextTierOption.quantity - (compareWith || 0)) * 100) / 100,
                            money_format,
                            currency,
                            true,
                            "string",
                        )}`,
                    )
                    .replace(
                        "{discount}",
                        getDiscountValueWithSignString(
                            nextTierOption.discountType,
                            nextTierOption.discountValue || 0,
                            currency,
                            money_format,
                        ) as string,
                    );
                setTierSuccessMessage(msg);
            } else {
                if (isTierCompleted) {
                    setTierSuccessMessage(
                        bundleConfig?.discount_options.find((opt) => opt.showFinalSuccessMessage)
                            ?.finalSuccessMessage || "",
                    );
                } else setTierSuccessMessage("");
            }
        } else {
            setDiscountType(bundleConfig?.discount_type);
            setDiscountValue(bundleConfig?.discount_value);
            setTierSuccessMessage("");
        }
    }, [
        bundleConfig?.discount_type,
        bundleConfig?.discount_value,
        bundleConfig?.discount_options,
        totalQuantity,
        normalTotalQuantity,
        totalPrice,
        selectedVariants,
    ]);

    useEffect(() => {
        // @ts-expect-error hack
        if (standAlone && bundleConfig?.form_id && bundleConfig?.shop) {
            updateBundleStats({
                id: bundleConfig?.form_id,
                key: "views",
                // @ts-expect-error hack
                shop: bundleConfig?.shop,
                appName: appName,
                view_type: 5,
            });
        }
    }, [bundleConfig?.form_id, standAlone]);

    useEffect(() => {
        let _steps: ExtendedPlaceholderStepsType[] = [];
        if (bundleConfig?.steps?.length) {
            _steps = [
                ...(bundleConfig.steps.map((st) => ({
                    ...st,
                    review_step: false,
                    gift_step: st.step_content_type === "free_gift",
                })) as any),
            ];
        }

        setSteps(_steps);
    }, [bundleConfig?.steps]);

    useEffect(() => {
        if (placeholderMap) {
            setSelectedVariants(() => {
                const pArr: any[] = [];
                placeholderMap?.forEach((placeholder) => {
                    const arr = placeholder?.shells?.flatMap((product) =>
                        product?.selectedVariants?.map((variant: VariantsObj) => ({
                            ...product,
                            selectedVariants: product.selectedVariants.filter((psv: any) => psv?.id == variant?.id),
                            ...variant,
                            parentTitle: steps[activeStep]?.render_as_variants ? product.parentName : product.title,
                            parentProduct: product?.id,
                            subStepIdx: product?.subStepIdx,
                        })),
                    );

                    pArr?.push(...arr);
                });
                const grouped = pArr.reduce((acc, variant) => {
                    const existing = acc.find(
                        (v: any) =>
                            v.id === variant.id &&
                            v.parentProduct === variant.parentProduct &&
                            variant.page == v.page &&
                            variant.subStepIdx === v.subStepIdx,
                    );

                    if (existing) {
                        existing.qty += 1;
                    } else {
                        acc.push({ ...variant, qty: 1 });
                    }

                    return acc;
                }, [] as any[]); // optionally type your array if needed

                return grouped;
            });
        } else {
            setSelectedVariants([]);
        }
    }, [placeholderMap]);

    useEffect(() => {
        if (!selectedVariants || selectedVariants.length === 0) {
            setTotalQuantity(0);
            setNormalTotalQuantity(0);
            setFreeGiftTotalQuantity(0);
        } else {
            let total = 0;
            let normal = 0;
            let free = 0;
            selectedVariants.forEach((sv: any) => {
                const qty = sv?.selectedVariants?.length || 0;
                total += qty;
                if (sv?.freeGift) {
                    free += qty;
                } else {
                    normal += qty;
                }
            });
            setTotalQuantity(total);
            setNormalTotalQuantity(normal);
            setFreeGiftTotalQuantity(free);
        }
    }, [selectedVariants]);

    const handleAddProduct = (
        parentIdx: number,
        product: any,
        optType: "" | "inc" | "dec" | "add" = "",
        subStepIdx?: number,
    ) => {
        if (!optType) return;

        const effectiveSubStepIdx = product.subStepIdx !== undefined ? product.subStepIdx : subStepIdx;
        if (effectiveSubStepIdx !== undefined && effectiveSubStepIdx !== activeSubStep) {
            setActiveSubStep(effectiveSubStepIdx);
        }

        setPlaceholderMap((ps) => {
            const temp: PlaceholderMap[] = [...ps];
            const currentProducts = [...temp[parentIdx].shells];
            const pIdx = currentProducts?.findIndex(
                (cp) =>
                    cp?.id == product?.id &&
                    (effectiveSubStepIdx !== undefined ? cp?.subStepIdx === effectiveSubStepIdx : true),
            );
            if (optType == "dec" && pIdx >= 0) {
                let variantIndex = -1;
                variantIndex = currentProducts[pIdx].selectedVariants.findIndex(
                    (variant: any) => variant.id == product?.selectedVariants?.[0]?.id,
                );
                const svs =
                    currentProducts[pIdx]?.selectedVariants.filter((_: any, idx: number) => idx !== variantIndex) || [];
                if (svs?.length == 0) {
                    currentProducts?.splice(pIdx, 1);
                } else {
                    currentProducts[pIdx].selectedVariants = [...svs];
                }
            } else if (pIdx >= 0) {
                currentProducts[pIdx].selectedVariants.push({ ...product.selectedVariants[0] });
                currentProducts[pIdx].page = parentIdx;
            } else {
                currentProducts?.push({
                    ...product,
                    page: parentIdx,
                    subStepIdx: effectiveSubStepIdx,
                    selectedVariants: [product?.selectedVariants[0]],
                });
            }
            temp[parentIdx] = {
                ...temp[parentIdx],
                shells: [...currentProducts],
            };
            return temp;
        });
    };

    useEffect(() => {
        if (selectedVariants?.length > 0) {
            let tp = 0;
            selectedVariants.forEach((sv: VariantsObj) => {
                // @ts-expect-error required
                if (!sv?.freeGift) {
                    const pr = bundleConfig?.apply_discount_on_compare_price ? +sv.compareAtPrice : +sv.price;
                    // @ts-ignore
                    tp = tp + pr * +sv?.qty;
                }
            });
            setTotalPrice(tp);
        } else {
            setTotalPrice(0);
        }
    }, [selectedVariants, bundleConfig?.apply_discount_on_compare_price]);

    const loadMoreCollectionProducts = async (pgInfo: any = null) => {
        if (loadingMore) return; // Prevent multiple fetches
        const step = steps[activeStep];
        const currentStep = step?.enable_subSteps ? step.subSteps?.[activeSubStep] : step;
        const gid = currentStep?.collections?.[0]?.id;
        const id = gid?.split("/").pop() || "";
        if (!id) {
            setListProducts([]);
            return;
        }
        setLoadingMore(true);
        const { products, pageInfo: newPageInfo } = await fetchCollectionProducts(
            id,
            sft,
            setLoadingMore,
            standAlone,
            fetchCount,
            pgInfo?.endCursor || null,
        );

        setListProducts((prevProducts) => {
            const merged = [...prevProducts, ...products];

            const selectedProds = selectedVariants
                .filter((variant) => variant?.page == activeStep)
                .map((variant) => variant?.parentProduct);
            const sortedMerged = [
                ...merged.filter((product) => selectedProds.includes(product.id)), // Selected first
                ...merged.filter((product) => !selectedProds.includes(product.id)), // Rest in original order
            ];

            const unique = bundleConfig?.hide_out_of_stock_products
                ? Array.from(new Map(sortedMerged.map((p) => [p.id, p])).values()).filter(filterInStockProducts)
                : Array.from(new Map(sortedMerged.map((p) => [p.id, p])).values());

            const finalList = bundleConfig?.allow_conditional_logic
                ? applyConditionsBB(bundleConfig?.product_conditions, selectedVariants, unique)
                : unique;
            if (finalList.length == 0 && standAlone) {
                const goToStep = sessionStorage.getItem("goToStep");
                setActiveStep((prev) => {
                    if (goToStep == "prev") {
                        return prev == 0 ? prev : prev - 1;
                    } else {
                        return prev == steps?.length - 1 ? prev : prev + 1;
                    }
                });
            }
            return finalList;
        });
        setPageInfo(newPageInfo);
        setLoadingMore(false);
    };

    useEffect(() => {
        if (listProducts?.length) {
            window?.localStorage.setItem("placeholder_handle", listProducts[0]?.handle);
        }
    }, [listProducts]);

    useEffect(() => {
        // this only runs once at start, and fills the preselected products
        const getRealTimeProducts = async () => {
            const preSelected = bundleConfig?.pre_selected_products || [];
            const finalProducts = await getUpdatedVariants(preSelected, sft, bundleConfig.steps, standAlone);

            setPlaceholderMap((ps: PlaceholderMap[]) => {
                const temp: PlaceholderMap[] = [...ps];
                temp.forEach((page) => {
                    if (page?.shells) {
                        page.shells = [];
                    }
                });
                finalProducts.forEach((product) => {
                    const page = product?.page;
                    temp[+page]?.shells?.push(product);
                });
                return temp;
            });
        };

        getRealTimeProducts();
    }, [bundleConfig?.pre_selected_products, bundleConfig?.steps]);

    const getProductsStepWise = (step: any) => {
        const currentStep = step.enable_subSteps ? step.subSteps?.[activeSubStep] : step;

        switch (currentStep?.product_selection) {
            case "collection":
                (async () => {
                    setLoadingProducts(true);
                    setLoadingMore(false);
                    await loadMoreCollectionProducts(null);
                    setLoadingProducts(false);
                })();
                break;
            case "specific":
                (async () => {
                    setLoadingProducts(true);
                    const newConfig = await updateBundleConfigWithRealTimeProducts(
                        sft,
                        [{ ...bundleConfig, products: [...(currentStep?.products || [])] }],
                        standAlone,
                    );

                    const rawList = bundleConfig?.hide_out_of_stock_products
                        ? newConfig[0]?.products?.filter(filterInStockProducts) || []
                        : newConfig[0]?.products || [];

                    let finalList = bundleConfig?.allow_conditional_logic
                        ? applyConditionsBB(bundleConfig?.product_conditions, selectedVariants, rawList)
                        : rawList;

                    finalList = finalList.map((item) => {
                        const mainItem = (currentStep?.products || []).find((m: ProductObj) => m.id === item.id);
                        return {
                            ...item,
                            variants: mainItem
                                ? item.variants.filter(
                                      (v) => mainItem.variants.findIndex((t: VariantsObj) => t.id == v.id) >= 0,
                                  )
                                : [],
                        };
                    });

                    if (finalList.length == 0 && standAlone) {
                        const goToStep = sessionStorage.getItem("goToStep");
                        setActiveStep((prev) => {
                            if (goToStep == "prev") {
                                return prev == 0 ? prev : prev - 1;
                            } else {
                                return prev == steps?.length - 1 ? prev : prev + 1;
                            }
                        });
                    }
                    const selectedProds = selectedVariants
                        .filter((variant) => variant?.page == activeStep)
                        .map((variant) => variant?.parentProduct);
                    const sortedMerged = [
                        ...finalList.filter((product) => selectedProds.includes(product.id)), // Selected first
                        ...finalList.filter((product) => !selectedProds.includes(product.id)), // Rest in original order
                    ];

                    setListProducts([...sortedMerged]);
                    setLoadingProducts(false);
                })();
                break;
            default:
                setListProducts([]);
        }
    };

    const searchWithPredictive = async (query: string) => {
        const step = steps[activeStep];
        if (!step?.enable_subSteps || !query?.trim()) {
            setPredictiveResults([]);
            return;
        }

        const collectionToSubStepMap: Record<string, number> = {};
        // Map of allowed product IDs -> substep index for specific substeps
        const specificProductToSubStepMap: Record<string, number[]> = {};

        step.subSteps?.forEach((ss: any, idx: number) => {
            if (ss.product_selection === "collection" && ss.collections?.length) {
                ss.collections.forEach((col: any) => {
                    collectionToSubStepMap[col.id] = idx;
                });
            } else if (ss.product_selection === "specific" && ss.products?.length) {
                ss.products.forEach((p: ProductObj) => {
                    if (specificProductToSubStepMap[p.id]) {
                        specificProductToSubStepMap[p.id].push(idx);
                    } else {
                        specificProductToSubStepMap[p.id] = [idx];
                    }
                });
            }
        });

        const hasAnything =
            Object.keys(collectionToSubStepMap).length > 0 || Object.keys(specificProductToSubStepMap).length > 0;

        if (!hasAnything) {
            setPredictiveResults([]);
            return;
        }

        try {
            // Cancel previous request
            if (abortControllerRef.current) {
                abortControllerRef.current.abort();
            }

            const controller = new AbortController();
            abortControllerRef.current = controller;

            setIsSearching(true);

            const response = await fetch(`https://${userShopname}/api/2026-01/graphql.json`, {
                method: "POST",
                signal: controller.signal,
                headers: {
                    "Content-Type": "application/json",
                    "X-Shopify-Storefront-Access-Token": sft,
                },
                body: JSON.stringify({
                    query: `
                    query predictiveSearch($query: String!) {
                      predictiveSearch(query: $query, types: [PRODUCT], limit: 10) {
                        products {
                          id
                          title
                          handle
                          options {
                            name
                            values
                          }
                          featuredImage {
                            url
                            altText
                          }
                          variants(first: 100) {
                            nodes {
                              id
                              title
                              price {
                                amount
                                currencyCode
                              }
                              compareAtPrice {
                                amount
                                currencyCode
                              }
                              availableForSale
                              selectedOptions {
                                name
                                value
                              }
                            }
                          }
                          collections(first: 50) {
                            nodes {
                              id
                            }
                          }
                        }
                      }
                    }
                `,
                    variables: { query },
                }),
            });

            const json = await response.json();
            const products = json?.data?.predictiveSearch?.products || [];

            const formatted: any[] = [];

            products.forEach((p: any) => {
                let subStepIdx: number | undefined;

                for (const col of p.collections?.nodes || []) {
                    if (collectionToSubStepMap[col.id] !== undefined) {
                        subStepIdx = collectionToSubStepMap[col.id];
                        break;
                    }
                }

                if (subStepIdx === undefined && specificProductToSubStepMap[p.id] !== undefined) {
                    subStepIdx = specificProductToSubStepMap[p.id][0];
                }

                if (subStepIdx === undefined) return;

                // For specific substeps, filter variants to only allowed ones
                const allowedVariantIds =
                    specificProductToSubStepMap[p.id] !== undefined
                        ? new Set(
                              step?.subSteps?.[specificProductToSubStepMap[p.id][0]].products
                                  .find((sp: ProductObj) => sp.id === p.id)
                                  ?.variants?.map((v: VariantsObj) => v.id) || [],
                          )
                        : null;
                const variants = p.variants.nodes
                    .filter((v: any) => !allowedVariantIds || allowedVariantIds.has(v.id))
                    .filter((v: any) => (bundleConfig?.hide_out_of_stock_products ? v.availableForSale : true))
                    .map((v: any) => ({
                        id: v.id,
                        title: v.title,
                        price: v.price.amount,
                        compareAtPrice: v.compareAtPrice?.amount || v.price.amount,
                        availableForSale: v.availableForSale,
                        selectedOptions: v.selectedOptions,
                    }));

                if (!variants.length) return;

                formatted.push({
                    id: p.id,
                    title: p.title,
                    handle: p.handle,
                    subStepIdx,
                    images: p.featuredImage
                        ? [{ originalSrc: p.featuredImage.url, altText: p.featuredImage.altText, id: p.id }]
                        : [],
                    variants,
                    selectedVariants: [variants[0]],
                    options: p.options,
                    quantity: 1,
                    checked: false,
                });
            });

            setPredictiveResults(formatted);

            if (formatted.length > 0) {
                const firstResultSubStepIdx = formatted[0].subStepIdx;
                if (firstResultSubStepIdx !== undefined && firstResultSubStepIdx !== activeSubStep) {
                    setActiveSubStep(firstResultSubStepIdx);
                }
            }
        } catch (error: any) {
            if (error.name !== "AbortError") {
                console.error("Predictive search failed:", error);
            }
        } finally {
            setIsSearching(false);
        }
    };

    useEffect(() => {
        const step = steps[activeStep];
        const hasAnySubSteps = step?.enable_subSteps && step?.subSteps && step?.subSteps?.length > 0;

        if (debouncedSearchQuery?.trim()?.length > 1 && hasAnySubSteps) {
            searchWithPredictive(debouncedSearchQuery.trim());
        } else {
            setPredictiveResults([]);
        }
    }, [debouncedSearchQuery, activeStep]);

    useEffect(() => {
        if (steps[activeStep]?.step_content_type == "products" || steps[activeStep]?.step_content_type == "free_gift") {
            setPageInfo(null);
            setListProducts([]);
            getProductsStepWise(steps[activeStep]);
        } else {
            setPageInfo(null);
            setListProducts([]);
        }
    }, [
        steps[activeStep]?.step_content_type,
        steps[activeStep]?.product_selection,
        steps[activeStep]?.products,
        steps[activeStep]?.collections,
        steps[activeStep]?.enable_subSteps,
        steps[activeStep]?.subSteps,
        activeSubStep,
        bundleConfig?.hide_out_of_stock_products,
        placeholderStepsModal,
    ]);

    useEffect(() => {
        const trigger = loadMoreTriggerRef.current;
        const scrollContainer = productListRef.current;

        if (!trigger || !scrollContainer || !pageInfo?.hasNextPage) return;

        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting && !loadingMore) {
                    observer.disconnect();
                    loadMoreCollectionProducts(pageInfo);
                }
            },
            {
                root: scrollContainer,
                threshold: 0.2,
            },
        );

        observer.observe(trigger); // observe latest trigger

        return () => {
            observer.unobserve(trigger); // cleanup previous trigger
            observer.disconnect();
        };
    }, [pageInfo?.hasNextPage, loadMoreTriggerRef, listProducts.length]);

    useEffect(() => {
        const count = getCurrentPageSelectCount(selectedVariants, activeStep);
        const total = getCurrentPageSelectTotal(selectedVariants, activeStep);
        setCurrentPageSelectCount(count);
        setCurrentPageSelectTotal(total);
    }, [selectedVariants, activeStep]);

    const isNextAllowed = (step: StepsType) => {
        if (step?.show_step_conditions === false) {
            return true;
        }
        if (!step?.step_content_type) {
            return true;
        }

        const conditions = step?.step_conditions;

        return checkForStepConditions(conditions, currentPageSelectCount, currentPageSelectTotal);
    };

    // useEffect to set Step/SubStep Error Msg
    useEffect(() => {
        if (steps[activeStep]?.show_step_conditions === false && !steps[activeStep].gift_step) {
            setNextErrorMsg([]);
            return;
        }

        if (steps[activeStep]) {
            const msg: string[] = [];
            let stepMsg = "";
            if (steps[activeStep]?.step_conditions) {
                steps[activeStep]?.step_conditions?.forEach((condition: StepConditionType) => {
                    stepMsg = "";
                    stepMsg = getValidErrorMsg(
                        steps[activeStep],
                        condition,
                        currentPageSelectCount,
                        currentPageSelectTotal,
                        currency,
                        currencyToSymbols,
                    );
                    if (stepMsg) {
                        msg.push(stepMsg);
                    }
                });
            }

            if (steps[activeStep].gift_step) {
                stepMsg = getValidErrorMsg(
                    steps[activeStep],
                    {
                        basis: "items_count",
                        type: steps[activeStep]?.step_condition_type,
                        limit: +(steps[activeStep]?.product_count_limit || 0),
                        msg: steps[activeStep]?.step_error_msg,
                    },
                    currentPageSelectCount,
                    currentPageSelectTotal,
                    currency,
                    currencyToSymbols,
                );
                if (stepMsg) {
                    msg.push(stepMsg);
                }
            }

            if (msg) {
                setNextErrorMsg(msg);
            } else {
                setNextErrorMsg([]);
            }
        }
    }, [currentPageSelectCount, activeStep, steps, selectedVariants]);

    const disableCtas = (step: ExtendedPlaceholderStepsType) => {
        if (step?.show_step_conditions === false) {
            return false;
        }

        return !showPlaceholderItem(step.step_conditions, currentPageSelectCount, currentPageSelectTotal);
    };

    const filterByQuery = (product: ProductObj) => {
        const query = searchQuery?.trim()?.toLowerCase() || "";
        if (!query) {
            return true;
        } else {
            if (product.handle?.toLowerCase().includes(query) || product.title?.toLowerCase().includes(query)) {
                return true;
            } else if (product.variants?.length) {
                let hasVariant = false;
                product?.variants.forEach((variant: VariantsObj) => {
                    if (variant?.title.toLowerCase()?.includes(query) && !hasVariant) {
                        hasVariant = true;
                    }
                });
                return hasVariant;
                // search variants array of VariantObj
            } else {
                return false;
            }
        }
    };

    const baseProducts = flatProductAsVariants(listProducts, !!steps[activeStep]?.render_as_variants);
    // When searching inside a substep-enabled step, search across ALL substeps' products
    const searchSourceProducts = useMemo(() => {
        if (!searchQuery?.trim() || !steps[activeStep]?.enable_subSteps) return baseProducts;
        return flatProductAsVariants(predictiveResults, !!steps[activeStep]?.render_as_variants);
    }, [searchQuery, predictiveResults, baseProducts, activeStep]);

    const filteredListProducts = bundleConfig?.hide_out_of_stock_products
        ? searchSourceProducts.filter(filterByQuery)?.filter(filterInStockProducts)
        : searchSourceProducts.filter(filterByQuery);

    useEffect(() => {
        if (placeholderStepsModal && standAlone) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }

        return () => {
            document.body.style.overflow = "";
        };
    }, [placeholderStepsModal]);
    console?._log("asdfasdfasf:selectedVariants", selectedVariants);

    const [failedStepIndex, setFailedStepIndex] = useState<number | null>(null);

    useEffect(() => {
        const checkDisable = () => {
            const failedStepIndex = bundleConfig.steps.findIndex((s, idx) => {
                if (s?.show_step_conditions === false) {
                    return false;
                }
                const stepConditions = s?.step_conditions;
                const totalItemsCount = getCurrentPageSelectCount(selectedVariants, idx);
                const total = getCurrentPageSelectTotal(selectedVariants, idx);

                return !checkForStepConditions(stepConditions, totalItemsCount, total);
            });

            return failedStepIndex !== -1 ? failedStepIndex : null;
        };

        const failedStep = checkDisable();

        const isSelectedVariantsEmpty = selectedVariants?.length === 0;

        const shouldDisableAddToCart = isSelectedVariantsEmpty || failedStep !== null;

        setIsAddCartDisabled(shouldDisableAddToCart);
        setFailedStepIndex(failedStep);
    }, [placeholderMap, selectedVariants]);

    const updatedBundleConfig = {
        ...bundleConfig,
        products: [{ selectedVariants }],
        discount_type: discountType,
        discount_value: discountValue,
        hasStepErrorsLeft: hasStepErrorsLeft,
        disableAddToCartButton: selectedVariants.length == 0,
        tooltipMessage: bundleConfig?.add_to_cart_cta_hover_text || "Products are required.",
    };
    console?._log("adsfasfads: placeholderMap", placeholderMap);
    return (
        <PlaceholderBundleContext.Provider
            value={{
                steps,
                setActiveStep,
                activeStep,
                activeSubStep,
                setActiveSubStep,
                selectedVariants,
                totalPrice,
                isMobile,
                bundleConfig: updatedBundleConfig,
                money_format,
                currency,
                standAlone,
                productListRef,
                isNextAllowed,
                getCurrentPageSelectCount,
                nextErrorMsg,
                boxQuantity,
                setBoxQuantity,
                totalQuantity,
                setTotalQuantity,
                normalTotalQuantity,
                setNormalTotalQuantity,
                freeGiftTotalQuantity,
                setFreeGiftTotalQuantity,
                tierSuccessMessage,
                setPlaceholderMap,
                placeholderMap,
                setPlaceholderStepsModal,
                allStepErrors,
                hasClickedAddToCartButton,
                userShopname,
                setSearchQuery,
                disableCtas,
                sft,
                actualConfigDiscountType: bundleConfig?.discount_type,
            }}
        >
            {bundleConfig?.selected_template_placeholder === "accordian" ? (
                <BundlePreviewWrapper
                    bundleConfig={updatedBundleConfig as any}
                    standAlone={standAlone}
                    currency={currency}
                    money_format={money_format}
                    totalPrice={totalPrice}
                    targetForm={targetForm}
                    hideBundleTitle={true}
                >
                    <PlaceholderAccordionTemplate
                        steps={steps}
                        placeholderMap={placeholderMap}
                        handleAddProduct={handleAddProduct}
                    />
                </BundlePreviewWrapper>
            ) : (
                <BundlePreviewWrapper
                    bundleConfig={updatedBundleConfig as any}
                    standAlone={standAlone}
                    currency={currency}
                    money_format={money_format}
                    totalPrice={totalPrice}
                    targetForm={targetForm}
                >
                    {placeholderMap?.length ? (
                        placeholderMap?.map((pm: PlaceholderMap, index: number) => {
                            return (
                                <PlaceholderSection
                                    placeholderItem={pm}
                                    setPlaceholderStepsModal={setPlaceholderStepsModal}
                                    index={index}
                                />
                            );
                        })
                    ) : (
                        <></>
                    )}
                </BundlePreviewWrapper>
            )}

            {placeholderStepsModal && (
                <PlaceholderStepsModal
                    onClose={() => setPlaceholderStepsModal(false)}
                    standAlone={standAlone}
                    isMobile={isMobile}
                    bundleConfig={bundleConfig}
                    inspectorMode={inspectorMode}
                    previewType={previewType}
                    placement={placement}
                >
                    <>
                        <div
                            className={styles.PlaceholderPagesWrapper}
                            style={{
                                fontFamily:
                                    bundleConfig?.bundles_design?.bundle_widget_font_family == "Custom Store Font"
                                        ? "inherit"
                                        : bundleConfig?.bundles_design?.bundle_widget_font_family,
                                width: "100%",
                                height: "100%",
                                marginTop:
                                    standAlone && bundleConfig?.bundles_design?.bb_margin_top
                                        ? bundleConfig?.bundles_design?.bb_margin_top
                                        : 0,
                            }}
                        >
                            {/* {steps?.length > 1 ? <StepsHeaderBar /> : <></>} */}
                            {steps?.length > 1 ? <StepsHeaderTabs /> : <></>}
                            {/* Data Wrapper Starts */}

                            <div className={styles.pageTitleSubtitleWrapper}>
                                {!!steps?.[activeStep]?.page_title && (
                                    <div
                                        className={styles.pageTitleWrapper}
                                        style={{
                                            fontSize: bundleConfig?.bundles_design?.step_page_title_size,
                                            color: bundleConfig?.bundles_design?.step_page_title_color,
                                            fontWeight:
                                                bundleConfig?.bundles_design?.step_page_title_style?.split(" ")[0] ??
                                                "550",
                                            fontStyle:
                                                bundleConfig?.bundles_design?.step_page_title_style?.split(" ")[1] ??
                                                "normal",
                                            width: isMobile ? "100%" : "70%",
                                        }}
                                    >
                                        {steps?.[activeStep]?.page_title}
                                    </div>
                                )}
                                {!!steps?.[activeStep]?.page_subtitle && (
                                    <div
                                        className={styles.pageTitleWrapper}
                                        style={{
                                            fontSize: bundleConfig?.bundles_design?.step_page_subtitle_size,
                                            color: bundleConfig?.bundles_design?.step_page_subtitle_color,
                                            fontWeight:
                                                bundleConfig?.bundles_design?.step_page_subtitle_style?.split(" ")[0] ??
                                                "550",
                                            fontStyle:
                                                bundleConfig?.bundles_design?.step_page_subtitle_style?.split(" ")[1] ??
                                                "normal",
                                            width: isMobile ? "100%" : "70%",
                                        }}
                                    >
                                        {steps?.[activeStep]?.page_subtitle}
                                    </div>
                                )}
                            </div>
                            {bundleConfig?.show_search_bar && !!listProducts?.length && (
                                <div
                                    className={styles.searchWrapper}
                                    style={{
                                        justifyContent: isMobile ? "center" : "flex-end",
                                        width: isMobile ? "100%" : "85%",
                                    }}
                                >
                                    <div className={`${styles.searchWrapperInput} ${searchActive && styles.active}`}>
                                        <input
                                            value={searchQuery}
                                            onFocus={() => setSearchActive(true)}
                                            placeholder={"Search Products"}
                                            onBlur={() => setSearchActive(false)}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                        />
                                        {isSearching ? (
                                            <Spinner
                                                size={16}
                                                color={bundleConfig?.bundles_design?.add_to_cart_bg_color}
                                            />
                                        ) : (
                                            <SearchIcon color={searchActive ? "black" : "#bdbdbd"} />
                                        )}
                                    </div>
                                </div>
                            )}
                            {steps?.[activeStep]?.enable_subSteps && <RenderSubStepBadges />}

                            <>
                                <div
                                    ref={productListRef}
                                    className={`${styles.productsWrapper} ${isMobile && styles.productsWrapperMobile}`}
                                    style={{
                                        flexGrow: 0,
                                        minWidth: "60%",
                                        paddingBottom: 140,
                                        // minHeight: listProducts.length == 0 && loadingMore ? "100vh" : "",
                                        // ...(!standAlone && { maxHeight: "52vh", overflowY: "auto" }),
                                        marginTop: 16,
                                        gridTemplateColumns: `repeat(auto-fit, minmax(${getPlaceholderCardWidth(
                                            isMobile
                                                ? bundleConfig?.product_card_mobile_size || "medium"
                                                : bundleConfig?.product_card_desktop_size || "medium",
                                            isMobile ? "mobile" : "desktop",
                                        )}, ${getPlaceholderCardWidth(
                                            isMobile
                                                ? bundleConfig?.product_card_mobile_size || "medium"
                                                : bundleConfig?.product_card_desktop_size || "medium",
                                            isMobile ? "mobile" : "desktop",
                                        )}))`,
                                        gap: getGapForSize(
                                            isMobile
                                                ? bundleConfig?.product_card_mobile_size
                                                : bundleConfig?.product_card_desktop_size,
                                            isMobile,
                                        ),
                                    }}
                                >
                                    {loadingProducts || isSearching ? (
                                        <div
                                            style={{
                                                minHeight: "35vh",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                margin: "auto",
                                            }}
                                        >
                                            <Spinner
                                                size={"5vw"}
                                                color={bundleConfig?.bundles_design?.add_to_cart_bg_color}
                                            />
                                        </div>
                                    ) : filteredListProducts?.length ? (
                                        <>
                                            {[...filteredListProducts]?.map((product: ProductObj, index: number) => {
                                                return (
                                                    <ProductCard
                                                        key={product?.id + product?.variants[0]?.id}
                                                        index={index}
                                                        product={product}
                                                        setTrackVariant={() => {}}
                                                        handleAddProduct={handleAddProduct}
                                                        isFreeGift={placeholderMap[activeStep].type == "free"}
                                                        disableCtas={disableCtas(steps[activeStep])}
                                                        currentStep={steps[activeStep]}
                                                        activeSubStep={activeSubStep}
                                                    />
                                                );
                                            })}
                                        </>
                                    ) : (
                                        <div className={styles.productsEmpty}>
                                            {standAlone ? "No Products Available" : "Configure Steps to See Preview"}
                                        </div>
                                    )}

                                    {listProducts.length > 0 && pageInfo?.hasNextPage && (
                                        <span
                                            ref={loadMoreTriggerRef}
                                            style={{
                                                display: "flex",
                                                justifyContent: "stretch",
                                                height: 10,
                                                width: "100%",
                                            }}
                                        ></span>
                                    )}
                                </div>
                                {loadingMore && (
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            minWidth: "60%",
                                        }}
                                    >
                                        <Spinner
                                            size={"5vw"}
                                            color={bundleConfig?.bundles_design?.add_to_cart_bg_color}
                                        />
                                    </div>
                                )}
                            </>
                        </div>
                        <PlaceholderBottomSection />
                    </>
                </PlaceholderStepsModal>
            )}
        </PlaceholderBundleContext.Provider>
    );
};

export default PlaceholderBundle;
